<template>
  <div class="NewsDetails">
    <!-- <banner img="../assets/img/bgtop.jpg" /> -->
    <div class="NewsDetails-product">
      <div class="wrap">
        <div class="tit">
          <h2 v-if="language == 'zh'"  v-text="newstitle"></h2>
          <h2 v-if="language == 'en'"  v-text="newstitleen"></h2>
          <p v-text="dateshow"></p>
        </div>
        <div class="text">
          <div v-if="language == 'zh'"  v-html="htmlContent"></div>
          <div v-if="language == 'en'"  v-html="htmlContenten"></div>
          <!-- <p>
            一月，UC-ELINK和全球知名猎头公司Hudson建立战略合作关系。双方将着眼于人才服务领域进行深度合作，推动留英学子和优质企业的对接。
          </p>
          <p>
            二月，UC-ELINK倾情赞助剑桥大学龙年春晚。
          </p>
          <p class="center"><img src="../assets/img/news/1.png" /></p>

          <p class="center"><img src="../assets/img/news/2.png" /></p>
          <p>
            二月，UC-ELINK和中国人力资源行业领先媒体公司HRoot建立战略合作关系，双方将在人才服务，内容共享，中国企业出海等诸多领域进行深度合作。
          </p>
          <p>
            三月，UC-ELINK和中国本土最大猎头公司嘉驰国际建立战略合作关系，双方将合作，将针对留英毕业生推出一站式的择业咨询，对接优质企业，帮助毕业生顺利就业。
          </p>
          <p>
            五月，UC-ELINK和英国最大的留学生社群红杉学社建立战略合作关系，双方将在人才服务，推动高端人才创业方面建立深度合作。
          </p>
          <p>
            六月，UC-ELINK和中国本土最大猎头公司嘉驰国际合作，正式推出中国留学生一对一择业咨询服务，双方优势互补，为中国海外学子提供职业规划、简历精修、笔/面试辅导、工作对接等服务，帮助毕业生顺利就业。
          </p>
          <p>
            八月，UC-ELINK推动中英之间高端人才交流，于八月十四至十五日，协助推动由华威大学副校长，英国皇家工程院院士顾赛教授为创始主席的英国杰出青年人才协会回国与上海临港发展（集团）有限公司、上海科技创业投资（集团）有限公司、上海杨浦科技创业（集团）有限公司、上海交通大学中银科技金融学院、上海国创科技产业创新发展中心、上海市国际股权投资基金协会等机构进行了交流。
            <br />&nbsp&nbsp&nbsp&nbsp&nbsp
            本次活动通过学术论坛、圆桌会议、政策讲座、项目路演、科技创业园区和知名科创企业参访等形式展开，旨在加强海内外的学术交流、创新项目对接，推动科技成果转化和产业升级，同时为海外的优秀博士人才提供更好的发展机会，共同助力上海高水平人才高地建设。
          </p> -->
        </div>
        <!-- <div class="cur">
            <a href="#">上一篇:北周地H0gan开息人才謝评国际化战略合作</a>
            <a href="#">下一篇:北周地H0gan开息人才謝评国际化战略合作</a>
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "NewsDetails",
  components: {
    Banner,
  },
  data() {
    return {
      pid: 0,
      newid:0,
      language: "",
      newsIdList: {},
      htmlContent:"",
      htmlContenten:"",
      dateshow:"",
      newstitle:"",
      newstitleen:"",
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.console.log(this.pid);
    this.language = this.$i18n.locale;
   // this.dateshow="2024年"+this.pid+"月16日";
    switch(this.pid.toString()) {
     case "1":
        this.newstitle="一月专题新闻"; 
        this.newstitleen="January Features"; 
        this.dateshow="2024年2月6日";
        break;
     case "2":
     this.newstitle="二月专题新闻";
     this.newstitleen="February Features"; 
     this.dateshow="2024年3月1日";
        break;
     case "3":
     this.newstitle="三月专题新闻";
     this.newstitleen="March Features"; 
     this.dateshow="2024年4月3日";
        break;
        case "5":
     this.newstitle="五月专题新闻";
     this.newstitleen="May Features"; 
     this.dateshow="2024年6月2日";
        break;
     case "6":
     this.newstitle="六月专题新闻";
     this.newstitleen="June Features"; 
     this.dateshow="2024年7月2日";
        break;
     case "8":
     this.newstitle="八月专题新闻";
     this.newstitleen="August Features"; 
     this.dateshow="2024年8月2日";
        break; 
     case "9":
     this.newstitle="二月专题新闻";
     this.newstitleen="February Features"; 
     this.dateshow="2025年2月10日";
        break; 
    case "10":
     this.newstitle="三月专题新闻";
     this.newstitleen="March Features"; 
     this.dateshow="2025年3月30日";
        break;
    case "11":
     this.newstitle="四月专题新闻";
     this.newstitleen="April Features"; 
     this.dateshow="2025年4月12日";
        break; 
    case "12":
     this.newstitle="十月专题新闻";
     this.newstitleen="October Features"; 
     this.dateshow="2025年10月25日";
        break; 
     default:
        console.log(this.pid);
    }
  }, 
  computed: {
    language2() {
      return this.$i18n.locale;
    },
  },
  watch: {
    language2: function(a, b) { 
      this.language=a
    },

  },
  mounted() {
    this.loadData();
    this.language = this.$i18n.locale;
  },
  methods: {
    loadData() {
      let param = new FormData();
      param = {
        newid : this.pid,
      };  
      this.$http
        .post( 
          //process.env.VUE_APP_BASE_API + "News/GetNewsById/${this.pid}
         "https://test2.uc-elink.co.uk/api/Content/GetNewsById/" +this.pid,
          {
            "Content-Type": "application/json;charset=UTF-8",
          }
        )
        .then((response) => {
          //console.log(response);
          this.htmlContent = response.data;
          window.console.log(this.newsIdList);
        })
        .catch(function(error) {
          window.console.log(error);
        }); 

        this.$http
        .post( 
          //process.env.VUE_APP_BASE_API + "News/GetNewsById/${this.pid}
          process.env.VUE_APP_BASE_API +"Content/GetNewsByIdEN/" +this.pid,
          {
            "Content-Type": "application/json;charset=UTF-8",
          }
        )
        .then((response) => {
          //console.log(response);
          this.htmlContenten = response.data;
          window.console.log(this.newsIdList);
        })
        .catch(function(error) {
          window.console.log(error);
        }); 
    },
  },
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        //height: 500px;
      }
      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
</style>
